module.exports = __webpack_public_path__ + "img/skate-quiz-synchronized-female.d29340cd.png";